export enum BrockmeyerCampaignStage {
  Active = 'active',
  Expired = 'expired',
}

export enum BrockmeyerCampaignSortAttribute {
  CreatedAt = 'created_at',
  DateEnd = 'date_end',
  JobTitle = 'job_title',
}

export enum BrockmeyerCampaignStatus {
  Draft = 'draft',
  PaymentPaid = 'payment_paid',
  PaymentPending = 'payment_pending',
  Online = 'online',
  Expired = 'expired',
}

export enum BrockmeyerChannelsSortAttribute {
  Name = 'name',
  Ranking = 'ranking',
  ListPrice = 'list_price',
  SuggestionScore = 'suggestion_score',
}
